import styled, { css } from "styled-components";

import { StatusIndicatorType } from "./index";

export const StyledStatusIndicator = styled.div<{ $type: StatusIndicatorType }>`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;

    ${({ $type, theme }) => {
        let color;

        switch ($type) {
            case "success":
                color = theme.colors.green;
                break;
            case "error":
                color = theme.dangerTypographyColor;
                break;
            case "warning":
                color = theme.colors.warning;
                break;
            case "neutral":
            default:
                color = theme.disabledTypographyColor;
                break;
        }

        return css`
            color: ${color};
        `;
    }};
`;
